export default __webpack_public_path__ + "static/media/selectDestinationTrancoso.efeee058.svg";